import {
  Divider,
  Modal,
  Spin,
  Form,
  Input,
  InputNumber,
  Button,
  Select,
  Radio,
  Card,
  Space,
  Upload,
  Row,
  Col,
  message,
  Checkbox,
} from "antd";
import { PlusOutlined, ExclamationCircleOutlined } from "@ant-design/icons";
import { useEffect, useState } from "react";
import { withRouter, useLocation } from "react-router-dom";
import QueryString from "qs";
import service from "../../../@services";
import config from "../../../@config";
import { getRequestHeader } from "../../../@utils/request.js";
import EditorComponent from "./EditorHtml";
import CategorySelect from "../../../components/CategorySelect";
import useAddBrand from "../hooks/useAddBrand";
import useAddPackage from "../hooks/useAddPackage";

const distributionType = [
  { label: "快递配送", value: "0" },
  { label: "门店自提", value: "1" },
];
const DefaultFormData = {
  barcode: "",
  name: "",
  merchantCategoryId: null,
  merchantCategoryName: null,
  specification: "",
  packageUnitName: null,
  packageUnitId: null,
  brandId: null,
  place: "",
  retailPrice: "",
  taxCategoryCode: "",
  taxCategoryId: "",
  taxName: null,
  taxRate: "",
  distribution: [],
};
export default withRouter(({ history, action }) => {
  const [form] = Form.useForm();
  const { search } = useLocation();
  const { addBrand } = useAddBrand();
  const { addPackage } = useAddPackage();
  const [barCodeValid, setBarCodeValid] = useState({});
  const [type, setProductType] = useState("");
  const [skuId, setSkuId] = useState();
  const [storeId, setStoreId] = useState();
  const [isSale, setOnlineSale] = useState();
  const [isDistribution, setIsDistribution] = useState([]);
  // 是否是门店创建
  const [isStoreCreate, setIsStoreCreate] = useState(false);
  const [brandOptions, setBrandOptions] = useState([]);
  const [packageOptions, setPackageUnitOptions] = useState([]);
  const [taxCategoryOptions, setTaxCategoryOptions] = useState([]);
  const [pageLoading, setPageLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  const [detail, setDetailValue] = useState("");
  const [salePrice, setSalePriceValue] = useState();
  const [categoryId, setCategoryId] = useState();
  const [deliveryArea, setDeliveryArea] = useState(null);
  const [fileList, setPictureFileList] = useState([]);
  const [areaOptions, setAreaOptions] = useState([]);
  useEffect(() => {
    getBrandList();
    getPackageUnitList();
    let query = QueryString.parse(decodeURIComponent(search.replace("?", "")));
    setProductType(query.type);
    setSkuId(query.skuId);
    setStoreId(query.storeId);
  }, [search]);
  useEffect(() => {
    action === "create" &&
      form.setFieldsValue({
        onlineSaleable: 0,
      });
  }, [action]);
  useEffect(() => {
    skuId ? getProductDetail(skuId) : form.setFieldsValue(DefaultFormData);
  }, [type, skuId]);
  useEffect(() => {
    if (!isDistribution.includes("0")) {
      form.setFieldsValue({
        deliveryArea: null,
      });
      setDeliveryArea(null);
    }
  }, [isDistribution]);
  const getBrandList = async (id) => {
    const data = await service.common.getBrandList();
    setBrandOptions(data);
    id &&
      form.setFieldsValue({
        brandId: id,
      });
  };
  const getPackageUnitList = async (id) => {
    const data = await service.common.getPackageUnitList();
    setPackageUnitOptions(data);
    id &&
      form.setFieldsValue({
        packageUnitId: id,
      });
  };
  const queryTaxCategory = async ({ target }) => {
    const data = await service.product.queryTaxCategory(target.value);
    setTaxCategoryOptions(data);
  };
  const handleSearch = async (newValue) => {
    if (newValue) {
      const params = {
        pageNum: 1,
        pageSize: 20,
        templateName: newValue,
      };
      const data = await service.area.getAreaPageList(params);
      setAreaOptions(data.result)
    } else {
      setAreaOptions([]);
    }
  };
  const handleChange = (newValue) => { 
    form.setFieldsValue({
      deliveryArea: newValue,
    });
    setDeliveryArea(newValue);
  };
  const selectTaxCategory = (taxCategory) => {
    form.setFieldsValue({
      taxCategoryCode: taxCategory.key,
      taxCategoryId: taxCategory.id,
    });
  };
  const onBarCodeChange = async ({ target }) => {
    const data = await service.product.checkBarCode(target.value);
    setBarCodeValid(
      !data
        ? {
          validateStatus: "error",
          errorMsg: "该条码已存在",
        }
        : {
          validateStatus: "success",
          errorMsg: null,
        }
    );
  };
  const selectCategory = (value, selectedOptions) => {
    if (selectedOptions.length > 0) {
      form.setFieldsValue({
        merchantCategoryId: selectedOptions[selectedOptions.length - 1].id,
        merchantCategoryName:
          selectedOptions[selectedOptions.length - 1].categoryName,
      });
    }
  };
  const selectPackage = (packageUnit) => {
    form.setFieldsValue({
      packageUnitName: packageUnit.key,
    });
  };
  const getProductDetail = async (skuId) => {
    setPageLoading(false);
    const data =
      type === "store"
        ? await service.product.getStoreProductDetail(skuId)
        : await service.product.getMerchantProductDetail(skuId);
    setPageLoading(false);
    // 配送方式
    data.deliveryMethod =
      data.deliveryMethod != null
        ? data.deliveryMethod + "" == "2"
          ? ["0", "1"]
          : [data.deliveryMethod + ""]
        : [];
    form.setFieldsValue(data);
    form.setFieldsValue({ deliveryAreaName: (data?.areaModels && data.areaModels[0]?.templateName) || '' })
    setIsDistribution(data.deliveryMethod);
    // 门店自建
    setIsStoreCreate(!!data.created);
    setDetailValue(data.detail);
    setSalePriceValue(data.salePrice);
    setCategoryId(data.merchantCategoryId);
    setDeliveryArea((data.deliveryArea || []).length > 0 ? data.deliveryArea[0] : null);
    if (data.pictures && data.pictures.length) {
      setPictureFileList(
        data.pictures.map((item) => {
          return { url: item };
        })
      );
    }
  };
  const createProduct = async () => {
    await form.validateFields();
    let pictures = fileList.map((item) => {
      return item.response.data;
    });
    let param = { storeId, pricingType: 0, type: 0 };
    let deliveryMethodStr = "";
    if (form.getFieldValue("deliveryMethod")) {
      const deliveryMethod = form.getFieldValue("deliveryMethod");
      if (deliveryMethod.length == 2) {
        deliveryMethodStr = "2";
      } else {
        deliveryMethodStr = deliveryMethod.join("");
      }
    }
    param = Object.assign(
      param,
      form.getFieldsValue(),
      { deliveryMethod: deliveryMethodStr },
      { detail: detail, pictures: pictures },
      { deliveryArea: [deliveryArea] }
    );
    setLoading(true);
    const res =
      type === "store"
        ? service.product.createStoreProduct(param)
        : service.product.createMerchantProduct(param);
    return res
      .then((data) => {
        type === "store"
          ? message.success("价格已提交审核，请耐心等待！")
          : message.success("商品数据保存成功");
        history.goBack();
      })
      .finally((e) => {
        setLoading(false);
      });
  };
  const saveProduct = async () => {
    await form.validateFields();
    let pictures = fileList.map((item) => {
      return item.url || (item.response && item.response.data);
    });
    let param = { storeId, pricingType: 0, type: 0 };
    if (type === "store") {
      param.storeSkuId = skuId;
    } else {
      param.skuId = skuId;
    }
    let deliveryMethodStr = "";
    if (form.getFieldValue("deliveryMethod")) {
      const deliveryMethod = form.getFieldValue("deliveryMethod");
      if (deliveryMethod.length == 2) {
        deliveryMethodStr = "2";
      } else {
        deliveryMethodStr = deliveryMethod.join("");
      }
    }
    param = Object.assign(
      param,
      form.getFieldsValue(),
      { deliveryMethod: deliveryMethodStr },
      { detail: detail, pictures: pictures },
      { deliveryArea: [deliveryArea] }
    );
    if (form.getFieldValue("salePrice") !== salePrice && type === "store") {
      Modal.confirm({
        title: "提示",
        icon: <ExclamationCircleOutlined />,
        content: `确认是否提交该销售价，提交后审核成功即可生效`,
        okText: "确认",
        cancelText: "取消",
        onOk: () => {
          setLoading(true);
          service.product
            .updateStoreProduct(param)
            .then((data) => {
              if (data) {
                Modal.confirm({
                  title: "提示",
                  icon: <ExclamationCircleOutlined />,
                  content: (
                    <div>
                      商品新销售价（&yen;{data.newPrice}
                      ）正在审核中，请勿重复提交～
                    </div>
                  ),
                  okText: "确认",
                  cancelText: "取消",
                });
              } else {
                message.success("价格已提交审核，请耐心等待！");
                history.goBack();
              }
            })
            .finally((e) => {
              setLoading(false);
            });
        },
      });
    } else {
      setLoading(true);
      const res =
        type === "store"
          ? service.product.updateStoreProduct(param)
          : service.product.updateMerchantProduct(param);
      return res
        .then((data) => {
          message.success("商品数据保存成功");
          history.goBack();
        })
        .finally((e) => {
          setLoading(false);
        });
    }
  };
  const beforeUpload = (file) => {
    const isJPG = file.type === "image/jpeg";
    const isPNG = file.type === "image/png";
    const isLt5M = file.size / 1024 / 1024 < 2;
    if (!isJPG && !isPNG) {
      message.error("上传图片只能是 jpg/png 格式!");
    }
    if (!isLt5M) {
      message.error("上传图片大小不能超过 2MB!");
    }
    return (isJPG || isPNG) && isLt5M ? true : Upload.LIST_IGNORE;
  };
  return (
    <Card style={{ textAlign: "left" }}>
      {pageLoading ? (
        <Spin />
      ) : (
        <Form
          labelCol={{ span: 3 }}
          wrapperCol={{ span: 15 }}
          form={form}
          initialValues={{ onlineSaleable: 0, distribution: [] }}
        >
          <Divider orientation="left">基础信息</Divider>
          <Form.Item label="商品类型" rules={[{ required: true }]}>
            标品
          </Form.Item>
          <Form.Item
            name="barcode"
            label="条码"
            rules={[
              { required: true, message: "请输入条码" },
              { pattern: /^[0-9a-zA-Z]*$/g, message: "条码只能输入字母和数字" },
            ]}
            validateStatus={barCodeValid.validateStatus}
            help={barCodeValid.errorMsg}
          >
            <Input
              style={{ width: "40%" }}
              disabled={action != "create"}
              placeholder="请输入"
              onChange={onBarCodeChange}
            />
          </Form.Item>
          <Form.Item
            name="name"
            label="商品名称"
            rules={[
              { required: true, message: "请输入商品名称" },
              {
                type: "string",
                max: 100,
                message: "商品名称最多只能输入100个字符",
              },
            ]}
          >
            <Input
              disabled={
                action == "detail" ||
                (type == "store" && action == "edit" && !isStoreCreate)
              }
              placeholder="请输入"
            />
          </Form.Item>
          <Form.Item
            name="merchantCategoryId"
            label="类别"
            rules={[{ required: true, message: "请选择类别" }]}
          >
            <CategorySelect
              categoryId={categoryId}
              disabled={
                action == "detail" || (type == "store" && action == "edit")
              }
              style={{ width: "40%" }}
              onChange={selectCategory}
            />
          </Form.Item>
          <Form.Item
            style={{ display: "none" }}
            name="merchantCategoryName"
            label="类别"
          >
            <Input disabled style={{ width: "40%" }} />
          </Form.Item>
          <Row>
            <Col span={9}>
              <Form.Item
                labelCol={{ span: 8 }}
                wrapperCol={{ span: 16 }}
                name="specification"
                label="商品规格"
                rules={[
                  { required: true, message: "请输入商品规格" },
                  {
                    type: "string",
                    max: 100,
                    message: "商品规格最多只能输入100个字符",
                  },
                ]}
              >
                <Input
                  disabled={
                    action == "detail" ||
                    (type == "store" && action == "edit" && !isStoreCreate)
                  }
                  placeholder="请输入"
                />
              </Form.Item>
            </Col>
            <Col span={9}>
              <Button
                disabled={
                  action == "detail" ||
                  (type == "store" && action == "edit" && !isStoreCreate)
                }
                style={{ float: "right" }}
                onClick={() => {
                  addPackage().then((packageUnitId) =>
                    getPackageUnitList(packageUnitId)
                  );
                }}
                icon={<PlusOutlined />}
              ></Button>
              <Form.Item
                labelCol={{ span: 8 }}
                wrapperCol={{ span: 16 }}
                name="packageUnitId"
                label="包装单位"
                rules={[{ required: true, message: "请选择包装单位" }]}
              >
                <Select
                  disabled={
                    action == "detail" ||
                    (type == "store" && action == "edit" && !isStoreCreate)
                  }
                  placeholder="请选择"
                  onChange={(value, option) => selectPackage(option)}
                  getPopupContainer={(triggerNode) =>
                    triggerNode.parentNode || document.body
                  }
                >
                  {packageOptions.map((item) => {
                    return (
                      <Select.Option key={item.name} value={item.id}>
                        {item.name}
                      </Select.Option>
                    );
                  })}
                </Select>
              </Form.Item>
              <Form.Item style={{ display: "none" }} name="packageUnitName">
                <Input disabled />
              </Form.Item>
            </Col>
          </Row>
          <Form.Item label="计价方式" rules={[{ required: true }]}>
            计件
          </Form.Item>
          <Row>
            <Col span={9}>
              <Button
                disabled={
                  action == "detail" ||
                  (type == "store" && action == "edit" && !isStoreCreate)
                }
                style={{ float: "right" }}
                onClick={() => {
                  addBrand().then((brandId) => getBrandList(brandId));
                }}
                icon={<PlusOutlined />}
              ></Button>
              <Form.Item
                labelCol={{ span: 8 }}
                wrapperCol={{ span: 16 }}
                name="brandId"
                label="品牌"
                rules={[{ required: true, message: "请选择品牌" }]}
              >
                <Select
                  disabled={
                    action == "detail" ||
                    (type == "store" && action == "edit" && !isStoreCreate)
                  }
                  placeholder="请选择"
                  getPopupContainer={(triggerNode) =>
                    triggerNode.parentNode || document.body
                  }
                >
                  {brandOptions.map((item) => {
                    return (
                      <Select.Option key={item.code} value={item.id}>
                        {item.name}
                      </Select.Option>
                    );
                  })}
                </Select>
              </Form.Item>
            </Col>
            <Col span={9}>
              <Form.Item
                labelCol={{ span: 8 }}
                wrapperCol={{ span: 16 }}
                name="place"
                label="产地"
              >
                <Input
                  disabled={
                    action == "detail" ||
                    (type == "store" && action == "edit" && !isStoreCreate)
                  }
                  placeholder="请输入"
                />
              </Form.Item>
            </Col>
          </Row>

          {type == "store" ? (
            <Form.Item
              name="onlineSaleable"
              label="售卖渠道"
              rules={[{ required: true, message: "请选择" }]}
            >
              <Radio.Group
                disabled={action == "detail"}
                onChange={({ target }) => setOnlineSale(target.value)}
              >
                <Radio value={2}>全部</Radio>
                <Radio value={0}>线下</Radio>
                <Radio value={1}>线上</Radio>
              </Radio.Group>
            </Form.Item>
          ) : (
            ""
          )}
          {form.getFieldValue("onlineSaleable") === 1 ||
            form.getFieldValue("onlineSaleable") === 2 ? (
            <Row>
              <Col span={3}></Col>
              <Col span={15}>
                <Form.Item name="stock" label="">
                  <InputNumber
                    max={99999}
                    style={{ width: "40%" }}
                    disabled={action == "detail"}
                    placeholder="请输入线上可售库存"
                  />
                </Form.Item>
              </Col>
            </Row>
          ) : (
            ""
          )}
          {form.getFieldValue("onlineSaleable") === 1 ||
            form.getFieldValue("onlineSaleable") === 2 ? (
            <Form.Item
              name="deliveryMethod"
              label="配送方式"
              rules={[{ required: true, message: "请选择配送方式" }]}
            >
              <Checkbox.Group
                disabled={action == "detail"}
                onChange={(val) => {
                  setIsDistribution(val);
                }}
                options={distributionType}
              ></Checkbox.Group>
            </Form.Item>
          ) : (
            ""
          )}
          {(form.getFieldValue("onlineSaleable") === 1 ||
            form.getFieldValue("onlineSaleable") === 2) &&
            isDistribution.includes("0") ? (
            <Form.Item
              name="deliveryAreaName"
              label="可售区域模板"
              rules={[{ required: true, message: "请选择模板" }]}
            >
              <Select
                showSearch
                placeholder='请输入模板名称进行查询'
                defaultActiveFirstOption={false}
                showArrow={false}
                filterOption={false}
                onSearch={handleSearch}
                onChange={handleChange}           
                notFoundContent={null}
                options={(areaOptions || []).map((item) => {
                  return {
                    value: item.id,
                    label: item.templateName
                  } })}
              />
            </Form.Item>
          ) : (
            ""
          )}
          <Divider orientation="left">价格信息</Divider>
          <Row>
            <Col span={9}>
              <Form.Item
                labelCol={{ span: 8 }}
                wrapperCol={{ span: 16 }}
                name="retailPrice"
                label="零售指导价"
              >
                <InputNumber
                  min={0}
                  max={99999}
                  formatter={(val) => val}
                  parser={(val) => (val - 0).toFixed(2)}
                  style={{ width: "100%" }}
                  disabled={
                    action == "detail" ||
                    (type == "store" && action == "edit" && !isStoreCreate)
                  }
                  placeholder="请输入"
                />
              </Form.Item>
            </Col>
            <Col span={9}>
              {type == "store" ? (
                <Form.Item
                  labelCol={{ span: 8 }}
                  wrapperCol={{ span: 16 }}
                  name="salePrice"
                  label="销售价"
                  rules={[{ required: true, message: "请输入销售价" }]}
                >
                  <InputNumber
                    min={0}
                    max={99999}
                    formatter={(val) => val}
                    parser={(val) => (val - 0).toFixed(2)}
                    style={{ width: "100%" }}
                    disabled={action == "detail"}
                    placeholder="请输入"
                  />
                </Form.Item>
              ) : (
                ""
              )}
            </Col>
          </Row>

          {type == "store" ? (
            <Row>
              <Col span={9}>
                <Form.Item
                  labelCol={{ span: 8 }}
                  wrapperCol={{ span: 16 }}
                  name="purchasePrice"
                  label="进货价"
                  rules={[{ required: true, message: "请输入采购进货价" }]}
                >
                  <InputNumber
                    min={0}
                    max={99999}
                    formatter={(val) => val}
                    parser={(val) => (val - 0).toFixed(2)}
                    style={{ width: "100%" }}
                    disabled={action == "detail"}
                    placeholder="请输入采购进货价"
                  />
                </Form.Item>
              </Col>
            </Row>
          ) : (
            ""
          )}
          <Row>
            <Col span={9}>
              <Form.Item
                labelCol={{ span: 8 }}
                wrapperCol={{ span: 16 }}
                name="taxCategoryCode"
                label="税收编码"
                rules={[
                  { required: true, message: "请输入税收编码" },
                  { type: "string", max: 19 },
                ]}
              >
                <Input
                  disabled={
                    action == "detail" ||
                    (type == "store" && action == "edit" && !isStoreCreate)
                  }
                  placeholder="请输入"
                  onBlur={queryTaxCategory}
                />
              </Form.Item>
            </Col>
            <Col span={9}>
              <Form.Item
                labelCol={{ span: 8 }}
                wrapperCol={{ span: 16 }}
                name="taxName"
                label="税收分类"
                rules={[{ required: true, message: "请选择税收分类" }]}
              >
                <Select
                  disabled={
                    action == "detail" ||
                    (type == "store" && action == "edit" && !isStoreCreate)
                  }
                  placeholder="请选择"
                  onChange={(value, option) => selectTaxCategory(option)}
                  getPopupContainer={(triggerNode) =>
                    triggerNode.parentNode || document.body
                  }
                >
                  {taxCategoryOptions.map((item) => {
                    return (
                      <Select.Option
                        id={item.id}
                        key={item.categoryCode}
                        value={item.name}
                      >
                        {item.name}
                      </Select.Option>
                    );
                  })}
                </Select>
              </Form.Item>
              <Form.Item style={{ display: "none" }} name="taxCategoryId">
                <Input disabled />
              </Form.Item>
            </Col>
          </Row>
          <Form.Item
            name="taxRate"
            label="税率"
            rules={[{ required: true, message: "请选择税率" }]}
          >
            <Select
              style={{ width: "40%" }}
              disabled={
                action == "detail" ||
                (type == "store" && action == "edit" && !isStoreCreate)
              }
              placeholder="请选择"
              getPopupContainer={(triggerNode) =>
                triggerNode.parentNode || document.body
              }
            >
              <Select.Option value={13}>13%</Select.Option>
              <Select.Option value={9}>9%</Select.Option>
              <Select.Option value={6}>6%</Select.Option>
              <Select.Option value={5}>5%</Select.Option>
              <Select.Option value={3}>3%</Select.Option>
              <Select.Option value={0}>0%</Select.Option>
            </Select>
          </Form.Item>
          <Divider orientation="left">商品图片：最多添加6张</Divider>
          <Row>
            <Col span={3}></Col>
            <Col span={15}>
              <Form.Item label="">
                <Upload
                  disabled={
                    action == "detail" ||
                    (type == "store" && action == "edit" && !isStoreCreate)
                  }
                  action={config.BASE_API + "/common/uploadPictureFile"}
                  headers={getRequestHeader()}
                  listType="picture-card"
                  beforeUpload={beforeUpload}
                  fileList={fileList}
                  onChange={({ fileList }) => setPictureFileList(fileList)}
                >
                  {fileList.length >= 6 ? null : (
                    <div>
                      <PlusOutlined />
                      <div style={{ marginTop: 8 }}>上传</div>
                    </div>
                  )}
                </Upload>
                <div>只能上传jpg/png文件，文件大小不能超过2mb</div>
              </Form.Item>
            </Col>
          </Row>
          <Divider orientation="left">商品详情</Divider>
          <Row>
            <Col span={20}>
              {action != "detail" &&
                !(type == "store" && action == "edit" && !isStoreCreate) ? (
                <EditorComponent detail={detail} setDetail={setDetailValue} />
              ) : (
                <Input.TextArea
                  style={{ margin: "20px 0" }}
                  disabled
                  value={detail}
                />
              )}
            </Col>
          </Row>
          <Space style={{ display: "flex", justifyContent: "center" }}>
            {action != "detail" ? (
              <Button
                loading={loading}
                type="primary"
                onClick={action === "create" ? createProduct : saveProduct}
              >
                保存
              </Button>
            ) : (
              ""
            )}
            <Button onClick={() => history.goBack()}>取消</Button>
          </Space>
        </Form>
      )}
    </Card>
  );
});
